import actionTypes from '../../common/actionTypes';

const initialState = {
	menuIsOpen: false,
};
export function toggleNavReducer(state: any = initialState, action: any) {
	switch (action.type) {
		case actionTypes.TOGGLE_NAV_MENU:
			return { ...state, menuIsOpen: !state.menuIsOpen };
		default:
			return state;
	}
} 

export default toggleNavReducer;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/navigation/navReducer.ts